"use client";

import dynamic from "next/dynamic";

const ClientOnlySearch = dynamic(() => import("./search-client"), {
  ssr: false,
});

export default function ClientOnlySearchWrapper(props) {
  return <ClientOnlySearch {...props} />;
}
